// The removal-request form on /takedown (contract P0, the public side).
//
// Posts { description, locator, contact?, attest: true } as JSON to
// POST /api/takedown and shows the case id and the 48-hour promise from the
// { id, dueAt } it gets back. The endpoint is built separately, so this page
// must stand on its own when it is not there yet: a 404 or a 503 reads as
// "not available right now", never as a broken page, and points at Support
// inside the app, which does reach a person. ASCII only.

const UNAVAILABLE = 'The removal channel is not available right now; write to support inside the app.';

const form = document.getElementById('takedown-form');
const status = document.getElementById('td-status');
const submit = document.getElementById('td-submit');

function say(text, kind) {
  if (!status) return;
  status.textContent = text;
  status.className = `notice${kind ? ` ${kind}` : ''}`;
  status.hidden = false;
}

function dueText(dueAt) {
  const t = new Date(dueAt);
  if (Number.isNaN(t.getTime())) return '';
  // The visitor's own clock and zone: it is a promise to them, not a log line.
  return ` That is by ${t.toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'short' })}.`;
}

if (form) {
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const description = form.elements.description.value.trim();
    const locator = form.elements.locator.value.trim();
    const contact = form.elements.contact.value.trim();
    const attest = form.elements.attest.checked;
    if (!description || !locator) {
      say('Please describe the image and say where you saw it.', 'err');
      return;
    }
    if (!attest) {
      say('Please confirm that you are the person in the image, or are acting for them.', 'err');
      return;
    }
    submit.disabled = true;
    say('Sending your request...');
    try {
      const body = { description, locator, attest: true };
      if (contact) body.contact = contact;
      const r = await fetch('/api/takedown', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (r.status === 404 || r.status === 503 || r.status === 502) {
        say(UNAVAILABLE, 'err');
        submit.disabled = false;
        return;
      }
      if (r.status === 429) {
        say('Too many requests from this connection just now. Please try again in a little while, or write to support inside the app.', 'err');
        submit.disabled = false;
        return;
      }
      if (!r.ok) {
        say('The request could not be sent. Check the description and where you saw it, and try again; if it keeps failing, write to support inside the app.', 'err');
        submit.disabled = false;
        return;
      }
      const data = await r.json().catch(() => ({}));
      const id = typeof data.id === 'string' ? data.id : '';
      say(
        `Your request has been received${id ? ` as case ${id}` : ''}. It will be acted on within 48 hours.${dueText(data.dueAt)} Keep the case id; it is how you refer to this request.`,
        'ok',
      );
      form.reset();
    } catch {
      say(UNAVAILABLE, 'err');
      submit.disabled = false;
    }
  });
}
